import { useForm } from 'react-hook-form'
import { FormObjectType, GiftRefundFormItemsType } from 'src/types/react-hook-form'
import { useModal } from 'src/provider/ModalContextProvider'
import {
  refundBankListQueryOption,
  serviceTermsQueryOption,
  useCustomQuery,
} from 'src/hooks/react-query/useCustomQuery.hook'
import { BankListSpace } from 'src/types/api'
import { NumReplace } from 'src/utils/regExps_util'

const useGiftRefundForm = (userPNumber: string) => {
  const { openModal } = useModal()
  const methods = useForm<GiftRefundFormItemsType>({
    mode: 'onChange',
    defaultValues: {
      name: '',
      pNumber: '',
      bankNum: '',
      accountNumber: '',
      termsAgree: false,
    },
  })
  const { setValue } = methods
  const { data: termsData } = useCustomQuery(serviceTermsQueryOption({ Type: 5 }))
  const { data: bankListData } = useCustomQuery(refundBankListQueryOption())
  const { BankInfo } = bankListData?.Body!
  const processBankInfo = BankInfo?.map((w: BankListSpace.BankList) => ({
    value: w.BankNum,
    text: w.BankName,
  }))

  const accountNumberOnChangeHandler = (event: { target: { value: string } }) => {
    setValue('accountNumber', NumReplace(event.target.value, 16), { shouldValidate: true })
  }
  const bankOnChangeHandler = (event: { target: { value: string } }) => {
    setValue('bankNum', event.target.value, { shouldValidate: true })
  }

  const registerAttribute: Record<keyof GiftRefundFormItemsType, Partial<FormObjectType>> = {
    name: {
      placeholder: '예금주명',
      type: 'text',
      tag: 'name',
      register_options: {
        required: '본인인증을 완료해주세요.',
      },
    },
    pNumber: {
      placeholder: '선물받은 분 휴대폰번호',
      type: 'text',
      tag: 'pNumber',
      register_options: {
        required: '본인인증을 완료해주세요.',
        pattern: {
          value: new RegExp(`^${userPNumber}$`),
          message:
            '쿠폰을 선물받은 수신자에게만 환불이 가능합니다. 고객센터 (1588-4531)로 문의해주시기 바랍니다.',
        },
      },
    },
    bankNum: {
      type: 'text',
      tag: 'bankNum',
      placeholder: '은행을 선택해주세요',
      optionValueList: processBankInfo,
      register_options: {
        onChange: bankOnChangeHandler,
        required: '은행을 선택해주세요.',
      },
    },
    accountNumber: {
      placeholder: '계좌번호를 입력해주세요',
      type: 'tel',
      tag: 'accountNumber',
      register_options: {
        required: '계좌번호를 정확히 입력해주세요.',
        onChange: accountNumberOnChangeHandler,
        minLength: { value: 8, message: '계좌번호를 정확히 입력해주세요.' },
        maxLength: 16,
        inputmode: 'numeric',
      },
    },
    termsAgree: {
      tag: 'termsAgree',
      labelValue: '(필수) 환불을 위해 개인정보 수집 및 이용에 동의합니다.',
      register_options: { required: true },
      labelOnClick: () =>
        openModal({
          button: { submit: { t: '닫기' } },
          contents: { t: termsData?.Body?.Title, d: termsData?.Body?.Contents },
        }),
    },
  }

  return {
    methods,
    registerAttribute,
  }
}
export default useGiftRefundForm
